import {
  SET_IS_TITLEBAR_TRIGGER_LIST_OPEN,
  SET_IS_TITLEBAR_EXECUTE_TRIGGER_LIST_OPEN,
  SET_EXECUTE_SELECTED_TRIGGER_ID,
  SHOW_TRIGGER_PROPERTIES_PANEL,
  HIDE_TRIGGER_PROPERTIES_PANEL,
  SET_SELECTED_TRIGGER,
  CLEAR_SELECTED_TRIGGER,
  SET_FLOW_TRIGGERS,
  CLEAR_FLOW_TRIGGERS,
  ADD_FLOW_TRIGGER,
  DELETE_FLOW_TRIGGER,
  UPDATE_FLOW_TRIGGER,
  OPEN_TRIGGER_DELETE_DIALOG,
  CLOSE_TRIGGER_DELETE_DIALOG,
  SET_TRIGGER_FOR_DELETE,
  CLEAR_TRIGGER_FOR_DELETE,
  START_DRAG_TRIGGER,
  STOP_DRAG_TRIGGER,
  TOGGLE_TRIGGER,
  SET_SELECTED_SCHEDULE,
} from "redux/constants/flowDesigner";

const initialState = {
  showTriggerPropertiesPanel: false,
  isTitlebarTriggersTriggerListOpen: false,
  isTitlebarExecuteTriggerListOpen: false,
  flowTriggers: [],
  executeSelectedTriggerId: null,
  selectedTrigger: null,
  showTriggerDeleteDialog: false,
  triggerForDelete: null,
  triggerDragInProgress: false,
  selectedSchedule: null,
};

const triggers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_IS_TITLEBAR_TRIGGER_LIST_OPEN:
      return {
        ...state,
        isTitlebarTriggerListOpen: payload,
      };
    case SET_IS_TITLEBAR_EXECUTE_TRIGGER_LIST_OPEN:
      return {
        ...state,
        isTitlebarExecuteTriggerListOpen: payload,
      };
    case SET_EXECUTE_SELECTED_TRIGGER_ID:
      return {
        ...state,
        executeSelectedTriggerId: payload,
      };
    case SHOW_TRIGGER_PROPERTIES_PANEL:
      return {
        ...state,
        showTriggerPropertiesPanel: true,
      };
    case HIDE_TRIGGER_PROPERTIES_PANEL:
      return {
        ...state,
        showTriggerPropertiesPanel: false,
      };
    case SET_SELECTED_TRIGGER:
      return {
        ...state,
        selectedTrigger: payload,
      };
    case CLEAR_SELECTED_TRIGGER:
      return {
        ...state,
        selectedTrigger: null,
      };

    case SET_FLOW_TRIGGERS:
      return {
        ...state,
        flowTriggers: payload,
      };
    case CLEAR_FLOW_TRIGGERS:
      return {
        ...state,
        flowTriggers: [],
      };
  case ADD_FLOW_TRIGGER: {
    const alreadyExists = state.flowTriggers.some(
      (trigger) => trigger.type === payload.type
    );
    if (alreadyExists) return state;
    return {
      ...state,
      flowTriggers: [...state.flowTriggers, payload],
    };
  }
    case DELETE_FLOW_TRIGGER:
      return {
        ...state,
        flowTriggers: state.flowTriggers.filter(
          (trigger) => trigger.type !== state.triggerForDelete?.type
        ),
      };
    case UPDATE_FLOW_TRIGGER:
      return {
        ...state,
        flowTriggers: state.flowTriggers.map((trigger) => {
          if (trigger.type === payload.type) {
            return payload;
          }
          return trigger;
        }),
      };
    case TOGGLE_TRIGGER:
      return {
        ...state,
        flowTriggers: state.flowTriggers.map((trigger) => {
          if (trigger.type === payload.type) {
            return {
              ...trigger,
              disabled: !trigger.disabled,
            };
          }
          return trigger;
        }),
      };
    case OPEN_TRIGGER_DELETE_DIALOG:
      return {
        ...state,
        showTriggerDeleteDialog: true,
      };
    case CLOSE_TRIGGER_DELETE_DIALOG:
      return {
        ...state,
        showTriggerDeleteDialog: false,
      };
    case SET_TRIGGER_FOR_DELETE:
      return {
        ...state,
        triggerForDelete: payload,
      };
    case CLEAR_TRIGGER_FOR_DELETE:
      return {
        ...state,
        triggerForDelete: null,
      };
    case START_DRAG_TRIGGER:
      return {
        ...state,
        triggerDragInProgress: true,
      };
    case STOP_DRAG_TRIGGER:
      return {
        ...state,
        triggerDragInProgress: false,
      };
    case SET_SELECTED_SCHEDULE:
      return {
        ...state,
        selectedSchedule: payload,
      };
  }
  return state;
};

export default triggers;
